import Config from '../../AppConfig';
import { FinancialPlanningSoftware } from '../domains/epi.domain';
import { get } from './core/fetch';

export const getProducts = async (): Promise<FinancialPlanningSoftware[]> => {
	try {
		const json: any = await get(Config.mlcApiPrefix + `/epiFPS`, {
			withAuth: true,
			noGateway: false,
		});
		return json;
	} catch (e) {
		// TODO: Hardcoded values for testing
		return [];
	}
};
